// Shared localStorage key used to bounce an unauthenticated reader back to
// the gated page they came from (e.g. the What's New blur-wall popup) once
// they finish signing up or logging in.
export const POST_AUTH_REDIRECT_KEY = 'viveka_post_auth_redirect';

const PARTICIPANT_DASHBOARD = '/v-coach/client/dashboard';

// Coach workspace pages. Listed explicitly rather than matching the
// `/v-coach/` prefix, because that prefix also covers participant pages
// (/v-coach/client/...), marketing pages (/v-coach/whats-new) and
// role-agnostic links from emails (session-join, invitation-join, live
// session dashboards) that a participant must still be sent back to.
const COACH_ONLY_PATTERNS = [
  /^\/v-coach\/dashboard$/,
  /^\/v-coach\/settings$/,
  /^\/v-coach\/prospects(\/.*)?$/,
  /^\/v-coach\/clients(\/.*)?$/,
  /^\/v-coach\/(sessions|clients-activities)(\/[^/]+)?$/,
  /^\/v-coach\/reports$/,
  /^\/v-coach\/resources$/,
  /^\/v-coach\/programs(\/.*)?$/,
  /^\/v-coach\/profile\/testimonials$/,
  /^\/saas-chats\/coach$/,
];

export const isCoachOnlyPath = url => {
  const path = (url || '').split(/[?#]/)[0].replace(/\/+$/, '');
  return COACH_ONLY_PATTERNS.some(re => re.test(path));
};

// A participant logging in with a coach page as their backlink (e.g. the
// browser reopened the coach dashboard they once switched into) lands on
// the participant dashboard instead; any other backlink is kept.
export const participantSafeRedirect = url =>
  url && isCoachOnlyPath(url) ? PARTICIPANT_DASHBOARD : url;
